<section class="tipo-veiculo">
  <h2 class="tipo-veiculo__title">Produto</h2>
  <div class="tipo-veiculo__options">
    <app-button-selector *ngFor="let item of veiculos" [data]="item" [(selected)]="veiculo" (selectedChange)="onTipoVeiculoChange()">
    </app-button-selector>
  </div>
</section>

<app-new-modal-message #modalMessage [showFecharBtn]="false" [title]="'Atenção!'"></app-new-modal-message>